export enum CoreCareerApiTags {
  CareerList = 'CatalogCareerList',
}

export const coreCareerApiTagTypes = Array.from(Object.values(CoreCareerApiTags));
